/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const reviewValidationIssueDataSchema = z.object({
	field: z.string(),
	message: z.string(),
})

export type ReviewValidationIssueDataSchema = z.infer<typeof reviewValidationIssueDataSchema>
